namespace GeniuzPOS.AdvPromo {
    export interface PsAdvPromoHdAppForm {
        PromoCampaign: Serenity.LookupEditor;
        PmGroupId: Serenity.StringEditor;
        PmGroupDesc: Serenity.StringEditor;
        StartPromoDate: Serenity.DateEditor;
        EndPromoDate: Serenity.DateEditor;
        PromoTimeFg: Serenity.RadioButtonEditor;
        StartPromoTime: Common.EditTimeEditor;
        EndPromoTime: Common.EditTimeEditor;
        PromoDayFg: Serenity.RadioButtonEditor;
        PromoDay: Serenity.LookupEditor;
        PromoShopFg: Serenity.RadioButtonEditor;
        PromoShop: Serenity.LookupEditor;
        PromoCustFg: Serenity.EnumEditor;
        PromoMb: Serenity.LookupEditor;
        PromoStatus: Serenity.EnumEditor;
        PromoApproveFg: Serenity.EnumEditor;
        VenderSharing: Serenity.DecimalEditor;
        ItemList: PsAdvPromoItemEditor;
        ItemExList: PsAdvPromoItemExemptEditor;
        Item2List: PsAdvPromoItem2Editor;
        Item2ExList: PsAdvPromoItem2ExemptEditor;
        Item3List: PsAdvPromoItem3Editor;
        Item3ExList: PsAdvPromoItem3ExemptEditor;
        Item4List: PsAdvPromoItem4Editor;
        Item4ExList: PsAdvPromoItem4ExemptEditor;
        Item5List: PsAdvPromoItem5Editor;
        Item5ExList: PsAdvPromoItem5ExemptEditor;
        Item6List: PsAdvPromoItem6Editor;
        Item6ExList: PsAdvPromoItem6ExemptEditor;
        Item9List: PsAdvPromoItem9Editor;
        Item9ExList: PsAdvPromoItem9ExemptEditor;
    }

    export class PsAdvPromoHdAppForm extends Serenity.PrefixedContext {
        static formKey = 'AdvPromo.PsAdvPromoHdApp';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsAdvPromoHdAppForm.init)  {
                PsAdvPromoHdAppForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DateEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = Common.EditTimeEditor;
                var w5 = s.EnumEditor;
                var w6 = s.DecimalEditor;
                var w7 = PsAdvPromoItemEditor;
                var w8 = PsAdvPromoItemExemptEditor;
                var w9 = PsAdvPromoItem2Editor;
                var w10 = PsAdvPromoItem2ExemptEditor;
                var w11 = PsAdvPromoItem3Editor;
                var w12 = PsAdvPromoItem3ExemptEditor;
                var w13 = PsAdvPromoItem4Editor;
                var w14 = PsAdvPromoItem4ExemptEditor;
                var w15 = PsAdvPromoItem5Editor;
                var w16 = PsAdvPromoItem5ExemptEditor;
                var w17 = PsAdvPromoItem6Editor;
                var w18 = PsAdvPromoItem6ExemptEditor;
                var w19 = PsAdvPromoItem9Editor;
                var w20 = PsAdvPromoItem9ExemptEditor;

                Q.initFormType(PsAdvPromoHdAppForm, [
                    'PromoCampaign', w0,
                    'PmGroupId', w1,
                    'PmGroupDesc', w1,
                    'StartPromoDate', w2,
                    'EndPromoDate', w2,
                    'PromoTimeFg', w3,
                    'StartPromoTime', w4,
                    'EndPromoTime', w4,
                    'PromoDayFg', w3,
                    'PromoDay', w0,
                    'PromoShopFg', w3,
                    'PromoShop', w0,
                    'PromoCustFg', w5,
                    'PromoMb', w0,
                    'PromoStatus', w5,
                    'PromoApproveFg', w5,
                    'VenderSharing', w6,
                    'ItemList', w7,
                    'ItemExList', w8,
                    'Item2List', w9,
                    'Item2ExList', w10,
                    'Item3List', w11,
                    'Item3ExList', w12,
                    'Item4List', w13,
                    'Item4ExList', w14,
                    'Item5List', w15,
                    'Item5ExList', w16,
                    'Item6List', w17,
                    'Item6ExList', w18,
                    'Item9List', w19,
                    'Item9ExList', w20
                ]);
            }
        }
    }
}
